import { Font } from "@moneyforward/mfx_biz_react_components";
import { color } from "@/styles/theme";
import { css } from "@emotion/react";
import { SelectRowItemCell } from "@/components/atoms";
import { BankServices } from "@/generated/graphql_billing";

type Prop = {
  services: BankServices["services"];
};

export const PlanRowHeaderPart = ({ services }: Prop) => {
  return (
    <>
      {services?.map((service, idx) => (
        <SelectRowItemCell
          flexDirection="column"
          backgroundColor={idx % 2 === 1 ? color.gray100 : "inherit"}
          rightBorderDisplay={idx + 1 === services.length}
          externalStyleClass={
            idx + 1 === services.length ? externalStyleClass : null
          }
          key={`column-${idx}`}
        >
          {service.name.split(" ").map((nameWord, idx) => (
            <Font variant="s" key={`name-${idx}`}>
              {nameWord}
            </Font>
          ))}
        </SelectRowItemCell>
      ))}
      <SelectRowItemCell
        css={{ width: 5 }}
        rightBorderDisplay
        externalStyleClass={externalStyleClass}
      />
      <SelectRowItemCell
        rightBorderDisplay
        externalStyleClass={externalStyleClass}
      >
        <Font variant="s">その他サービス</Font>
      </SelectRowItemCell>
      <SelectRowItemCell
        css={{ width: 5 }}
        rightBorderDisplay
        externalStyleClass={externalStyleClass}
      />
      <SelectRowItemCell />
    </>
  );
};

const externalStyleClass = css({
  paddingTop: 0,
  paddingBottom: 0,
});
